// @flow
import type { ReservationStatus, DayStatus, DiscountType } from "./types"

export const reservationStatuses: {
  [ReservationStatus]: ReservationStatus,
} = {
  confirmed: "confirmed",
  checked_out: "checked_out",
  finished: "finished",
  cancelled: "cancelled",
}

export const dayStatus: { [DayStatus]: DayStatus } = {
  perks: "perks",
  past: "past",
  closed: "closed",
  closedHidePrice: "closedHidePrice",
  blocked: "blocked",
  available: "available",
  availableHidePrice: "availableHidePrice",
  closedSelected: "closedSelected",
  originalReservation: "originalReservation",
}

export const discountTypes: { [DiscountType]: DiscountType } = {
  subscription: "subscription",
  promocode: "promocode",
}



// WEBPACK FOOTER //
// ./src/data/reservations/constants.js